import { useState } from "react";
import { Endpoints } from "@brg/api";
import { WorldIcon } from "../../../../../_ftbl/main/assets/icons/WorldIcon";
import { COUNTRY_INDEX } from "../../../../../_ftbl/main/constants/countryIndexes";
import { FtblCoverFallbackCountry, FtblCoverFallbackFlag, FtblCoverImageFlag } from "./styles";
import {getFlagUrl} from "../../../../../_ftbl/main/helpers/getFlagUrl";

export const Flag = ({ countryId }: { countryId?: number }) => {
    const [hasError, setHasError] = useState(false);

    if (hasError) {
        return <FtblCoverFallbackFlag>
            <WorldIcon />
            <FtblCoverFallbackCountry>{COUNTRY_INDEX[countryId]}</FtblCoverFallbackCountry>
        </FtblCoverFallbackFlag>
    }

    return <FtblCoverImageFlag>
        <img
            src={getFlagUrl(countryId)}
            alt='flag'
            onError={() => setHasError(true)}
        />
    </FtblCoverImageFlag>
}
import { useState } from "react";
import { Endpoints } from "@brg/api";
import { WorldIcon } from "../../../../../_ftbl/main/assets/icons/WorldIcon";
import { COUNTRY_INDEX } from "../../../../../_ftbl/main/constants/countryIndexes";
import { FtblCoverFallbackCountry, FtblCoverFallbackFlag, FtblCoverImageFlag } from "./styles";
import {getFlagUrl} from "../../../../../_ftbl/main/helpers/getFlagUrl";

export const Flag = ({ countryId }: { countryId?: number }) => {
    const [hasError, setHasError] = useState(false);

    if (hasError) {
        return <FtblCoverFallbackFlag>
            <WorldIcon />
            <FtblCoverFallbackCountry>{COUNTRY_INDEX[countryId]}</FtblCoverFallbackCountry>
        </FtblCoverFallbackFlag>
    }

    return <FtblCoverImageFlag>
        <img
            src={getFlagUrl(countryId)}
            alt='flag'
            onError={() => setHasError(true)}
        />
    </FtblCoverImageFlag>
}
